import { GtmTrackingType } from '../constants';
import TrackingHelperInstance from './gtmTrackingHelper';
import GtmAddToBasketDelegatorInstance from './gtmAddToBasketDelegator';

class GtmReorderAddToBasketDelegator {
	constructor() {
		this.type = GtmTrackingType.REORDER_ADD_TO_BASKET;
		this.dataMapper = GtmAddToBasketDelegatorInstance.dataMapper;
		this.actionType = 'reorder';
	}

	getTrackingData(target, data) {
		const products = this.getAddedProducts(data);

		if (products.length) {
			return {
				event: 'addToCart',
				ecommerce: {
					add: {
						actionField: {
							list: TrackingHelperInstance.generateActionFieldString(),
							action_type: this.actionType,
						},
						products: products.map((product, index) =>
							TrackingHelperInstance.mapDataViaGtmKey(
								product,
								this.dataMapper,
								true,
								index + 1,
							),
						),
					},
				},
			};
		}
	}

	// Products added to the cart, as computed by the server (AddToCartValueProvider).
	// Entries that could not be added (e.g. out of stock) come back with a zero quantity.
	getAddedProducts(data) {
		return data && data.addToCart instanceof Array
			? data.addToCart.filter(product => Number(product.skuQty) > 0)
			: [];
	}
}

const GtmReorderAddToBasketDelegatorInstance =
	new GtmReorderAddToBasketDelegator();
export default GtmReorderAddToBasketDelegatorInstance;

// for test purpose only
export const GtmReorderAddToBasketDelegatorClass =
	GtmReorderAddToBasketDelegator;
